<script setup lang="ts">
import { onMounted, ref } from 'vue';

const hasMounted = ref(false);

onMounted(() => {
  // Flip the class on the next frame so the fade runs
  requestAnimationFrame(() => {
    hasMounted.value = true;
  });
});
</script>

<template>
  <div :class="[$style.box, hasMounted && $style.enter]">
    <slot />
  </div>
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;
.box {
  opacity: 0;
  transition: opacity 500ms ease-in;
  transition-delay: 500ms;
}

.enter {
  opacity: 1;
}

/* Accessibility: respect reduced motion */
@media (prefers-reduced-motion: reduce) {
  .box {
    transition: none !important;
  }
}
</style>
